import React from 'react';
import ModernGenogramApp from '../../src-modern/ModernGenogramApp';

const legendItems = [
  { status: 'active', label: '< 30 days', className: 'badge--success' },
  { status: 'warming', label: '30–60 days', className: 'badge--info' },
  { status: 'cooling', label: '60–90 days', className: 'badge--muted' },
  { status: 'inactive', label: '> 90 days', className: 'badge--warning' }
];

const GenogramPanel = () => {
  return (
    <div className="genogram-panel">
      <header className="genogram-panel__header">
        <div>
          <h2>Interactive Genogram</h2>
          <p>Visualize relationships and overlay activity badges directly on the network.</p>
        </div>
        <div className="genogram-panel__legend">
          {legendItems.map((item) => (
            <span key={item.status} className={`badge ${item.className}`}>
              {item.label}
            </span>
          ))}
        </div>
      </header>
      <div className="genogram-panel__canvas">
        <ModernGenogramApp />
      </div>
    </div>
  );
};

export default GenogramPanel;
